module.exports = __webpack_public_path__ + "img/pay_wx_tip.0d26c80e.png";